/**
 * FeatureTilesSection.jsx
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import FeatureTile from '../common/FeatureTile';
import './FeatureTilesSection.css';

const TILES_DATA = [
  {
    id: 'tile-risk',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Have_you_tried_quit_smoking.jpg/960px-Have_you_tried_quit_smoking.jpg',
    title: 'Spot smoking triggers',
    description: 'See which moments may make quitting harder.',
  },
  {
    id: 'tile-support',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Pen-writing-notes-studying.jpg/960px-Pen-writing-notes-studying.jpg',
    title: 'Get practical next steps',
    description: 'Turn your check in into practical next steps.',
  },
  {
    id: 'tile-progress',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Personal_organizer_with_metallic_ring_binder.jpg/960px-Personal_organizer_with_metallic_ring_binder.jpg',
    title: 'Plan difficult days',
    description: 'Forecast tough moments and track smoke free wins.',
  },
];

const FeatureTilesSection = () => {
  return (
    <section
      className="feature-tiles-section"
      aria-label="Why use QuitPact"
    >
      <p className="feature-tiles-section__eyebrow">What it does</p>
      <h2 className="feature-tiles-section__heading">
        Quick help for tough quit moments.
      </h2>

      <div className="feature-tiles-section__grid">
        {TILES_DATA.map((tile) => (
          <FeatureTile
            key={tile.id}
            imageUrl={tile.imageUrl}
            title={tile.title}
            description={tile.description}
          />
        ))}
      </div>
    </section>
  );
};

export default FeatureTilesSection;
